import React, {Component} from 'react'
import PropTypes from 'prop-types'


class StatisticsBySize extends Component {
    render() {
        const {sizes} = this.props

        if (!sizes || !sizes.length) return (
            <td>--</td>
        )

        return (
            <td className="StatisticsBySize">
                {sizes.map(sizeObject => {
                    const {size, total} = sizeObject

                    return (
                        <span key={size} className="Size">
                            <strong className="Name">{size}: </strong>
                            <span className="Total">{total}</span>
                        </span>
                    )
                })}
            </td>
        )
    }
}

StatisticsBySize.propTypes = {
    sizes: PropTypes.array.isRequired,
}

export default StatisticsBySize
